module.exports = __webpack_public_path__ + "media/Fillers/camera-f806f8bc.svg";